// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetShopOrderItemRequestModel from '../../model/get-shop-order-item-request-model';
import GetShopOrderItemRequestDTO from '../dto/get-shop-order-item-request-dto';
import dtoSchema from '../schemas/get-shop-order-item-request-schema';

export default abstract class GetShopOrderItemRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetShopOrderItemRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetShopOrderItemRequestDTO>): GetShopOrderItemRequestModel;
  static toModel(dto: DeepPartial<GetShopOrderItemRequestDTO> | undefined | null): GetShopOrderItemRequestModel | undefined;
  static toModel(dto: DeepPartial<GetShopOrderItemRequestDTO> | undefined | null): GetShopOrderItemRequestModel | undefined {
    return dto ? new GetShopOrderItemRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetShopOrderItemRequestModel> | GetShopOrderItemRequestModel): GetShopOrderItemRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetShopOrderItemRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetShopOrderItemRequestModel, can not map to GetShopOrderItemRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
